var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59844 0.693359L0 5.31641L4.59844 9.93946L5.81836 8.71953L3.26953 6.08985H11.577C14.2629 6.08985 16.3969 8.24844 16.3969 10.9098C16.3969 13.5957 14.2383 15.7297 11.577 15.7297H6.78926C6.35336 15.7297 6 16.0831 6 16.5189C6 16.9548 6.35336 17.3082 6.78926 17.3082H11.577C15.1207 17.3082 18 14.4289 18 10.8852C18 7.34141 15.1207 4.46211 11.577 4.46211H3.26602L5.81484 1.88516L4.59844 0.693359Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/goBack.8c7bd4a675796a7d6f76c108ec9443e9.svg";
export { ForwardRef as ReactComponent };